module.exports = __webpack_public_path__ + "img/cover4.2bcb6a46.png";